import { Radio as MantineRadio, RadioProps } from '@mantine/core';
import { FC, memo } from 'react';

import styles from './styles.module.css';

type Props = RadioProps;

export const Radio: FC<Props> = memo(({ ...props }) => {
  return (
    <MantineRadio
      classNames={{
        icon: styles.icon,
        inner: styles.inner,
        label: styles.label,
        radio: styles.radio,
        body: styles.body,
      }}
      {...props}
    />
  );
});
